import createApiServices from "./createApiServices"
import {BACKEND_URL, REPORT_URL} from "../ConfigUrlApi"

const api = createApiServices({baseUrl: REPORT_URL})
const api2 = createApiServices({baseUrl: 'https://admin.callstack.vn:9919/api'})
const api3 = createApiServices({baseUrl: BACKEND_URL})

export const reportCallFee = (payload) => {
  return api.makeRequestFull({
    url: `v1/report/Bao_cao_chi_tiet_cuoc/html/true`,
    method: 'POST',
    data: payload
  })
}

export const reportCallFeeNew = (payload) => {
  return api2.makeRequestFull({
    url: `v1/report/Bao_cao_chi_tiet_cuoc_new/html/true`,
    method: 'POST',
    data: payload
  })
}

export const reportHubPhoneNumber = (payload) => {
  return api.makeRequestFull({
    url: `v1/report/Bao_cao_dau_so/html/true`,
    method: 'POST',
    data: payload
  })
}

export const exportHubPhoneNumber = (payload) => {
  return api.makeRequestFull({
    url: `v1/report/Bao_cao_dau_so/xlsx/false`,
    method: 'POST',
    data: payload,
    responseType: 'blob',
  })
}

export const reportHubCustPhone = (payload) => {
  return api.makeRequestFull({
    url: `v1/report/Bao_cao_dau_so_khach_hang/html/true`,
    method: 'POST',
    data: payload
  })
}

export const reportHubCustPhoneV2 = (payload) => {
  return api.makeRequestFull({
    url: `v1/report/Bao_cao_dau_so_khach_hang_theo_huong/html/true`,
    method: 'POST',
    data: payload
  })
}

export const exportHubCustPhone = (payload) => {
  return api.makeRequestFull({
    url: `v1/report/Bao_cao_dau_so_khach_hang/xlsx/false`,
    method: 'POST',
    data: payload,
    responseType: 'blob',
  })
}

export const exportHubCustPhoneV2 = (payload) => {
  return api.makeRequestFull({
    url: `v1/report/Bao_cao_dau_so_khach_hang_theo_huong/xlsx/false`,
    method: 'POST',
    data: payload,
    responseType: 'blob',
  })
}

export const reportDetailSub = (payload) => {
  return api.makeRequestFull({
    url: `v1/report/Bao_cao_chi_tiet_cuoc_sub/html/true`,
    method: 'POST',
    data: payload
  })
}

export const exportDetailSub = (payload) => {
  return api.makeRequestFull({
    url: `v1/report/Bao_cao_chi_tiet_cuoc_sub/xlsx/false`,
    method: 'POST',
    data: payload,
    responseType: 'blob',
  })
}

export const exportDetailSubAppendix = (payload) => {
  return api.makeRequestFull({
    url: `v1/report/Bao_cao_phu_luc csk/xlsx/false`,
    method: 'POST',
    data: payload,
    responseType: 'blob',
  })
}

export const exportDetailSubAppendixZenify = (payload) => {
  return api.makeRequestFull({
    url: `v1/report/Bao_cao_phu_luc%20csk_zenify/xlsx/false`,
    method: 'POST',
    data: payload,
    responseType: 'blob',
  })
}

export const exportSubscriberUsage = (payload) => {
  return api.makeRequestFull({
    url: `v1/report/Bao_cao_phu_luc csk_new/xlsx/false`,
    method: 'POST',
    data: payload,
    responseType: 'blob',
  })
}

export const exportSubscriberUsageZenify = (payload) => {
  return api.makeRequestFull({
    url: `v1/report/Bao_cao_phu_luc%20csk_new_zenify/xlsx/false`,
    method: 'POST',
    data: payload,
    responseType: 'blob',
  })
}

export const reportOutputSub = (payload) => {
  return api.makeRequestFull({
    url: `v1/report/Bao_cao_san_luong_csk/html/true`,
    method: 'POST',
    data: payload
  })
}

export const exportReconSub = (payload) => {
  return api.makeRequestFull({
    url: `v1/report/Bao_cao_doi_soat csk/xlsx/false`,
    method: 'POST',
    data: payload,
    responseType: 'blob',
  })
}

export const exportReconSubZenify = (payload) => {
  return api.makeRequestFull({
    url: `v1/report/Bao_cao_doi_soat%20csk_zenify/xlsx/false`,
    method: 'POST',
    data: payload,
    responseType: 'blob',
  })
}

export const exportReconSubSystem = (payload) => {
  return api.makeRequestFull({
    url: `v1/report/Bao_cao_doi_soat csk_org/xlsx/false`,
    method: 'POST',
    data: payload,
    responseType: 'blob',
  })
}

export const exportReconSubSystemPayZenify = (payload) => {
  return api.makeRequestFull({
    url: `v1/report/De_nghi_thanh_toan_Zenify_org/xlsx/false`,
    method: 'POST',
    data: payload,
    responseType: 'blob',
  })
}

export const exportReconAgencyPayZenify = (payload) => {
  return api.makeRequestFull({
    url: `v1/report/De_nghi_thanh_toan_Zenify/xlsx/false`,
    method: 'POST',
    data: payload,
    responseType: 'blob',
  })
}

export const exportReconSystemPayCallStack = (payload) => {
  return api.makeRequestFull({
    url: `v1/report/De_nghi_thanh_toan_Callstack_org/xlsx/false`,
    method: 'POST',
    data: payload,
    responseType: 'blob',
  })
}

export const exportReconAgencyPayCallStack = (payload) => {
  return api.makeRequestFull({
    url: `v1/report/De_nghi_thanh_toan_Callstack/xlsx/false`,
    method: 'POST',
    data: payload,
    responseType: 'blob',
  })
}

export const exportAppendixDeleteNumberCallStack = (payload) => {
  return api.makeRequestFull({
    url: `v1/report/Phu_luc_huy_so_Callstack/xlsx/false`,
    method: 'POST',
    data: payload,
    responseType: 'blob',
  })
}

export const exportAppendixDeleteNumberZenify = (payload) => {
  return api.makeRequestFull({
    url: `v1/report/Phu_luc_huy_so_Zenify/xlsx/false`,
    method: 'POST',
    data: payload,
    responseType: 'blob',
  })
}

export const exportReconSubSystemZenify = (payload) => {
  return api.makeRequestFull({
    url: `v1/report/Bao_cao_doi_soat%20csk_org_zenify/xlsx/false`,
    method: 'POST',
    data: payload,
    responseType: 'blob',
  })
}

export const exportReconSubSystemNew = (payload) => {
  return api.makeRequestFull({
    url: `v1/report/Bao_cao_doi_soat csk_org_new/xlsx/false`,
    method: 'POST',
    data: payload,
    responseType: 'blob',
  })
}

export const exportReconSubSystemNewZenify = (payload) => {
  return api.makeRequestFull({
    url: `v1/report/Bao_cao_doi_soat%20csk_org_new_zenify/xlsx/false`,
    method: 'POST',
    data: payload,
    responseType: 'blob',
  })
}

export const reportBenefit = (payload) => {
  return api.makeRequestFull({
    url: `v1/report/Bao_cao_hoa_hong_sale/html/true`,
    method: 'POST',
    data: payload
  })
}

export const exportReportBenefit = (payload) => {
  return api.makeRequestFull({
    url: `v1/report/Bao_cao_hoa_hong_sale/xlsx/false`,
    method: 'POST',
    data: payload,
    responseType: 'blob',
  })
}

export const exportReportHistoryPayment = (payload) => {
  return api.makeRequestFull({
    url: `v1/report/report_topup_history_csk/xlsx/false`,
    method: 'POST',
    data: payload,
    responseType: 'blob',
  })
}

export const tenantNumberCSV = (userName, payload) => {
  return api3.makeRequestFull({
    url: `report/tenantNumberCSV?userName=${userName}`,
    method: 'POST',
    data: payload,
    responseType: 'blob',
  })
}
